import { render, staticRenderFns } from "./liveList.vue?vue&type=template&id=348fa5a4&scoped=true&"
import script from "./liveList.vue?vue&type=script&lang=js&"
export * from "./liveList.vue?vue&type=script&lang=js&"
import style0 from "./liveList.vue?vue&type=style&index=0&id=348fa5a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348fa5a4",
  null
  
)

export default component.exports